module.exports = __webpack_public_path__ + "assets/favicons/mstile-144x144.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader/dist/cjs.js?name=assets/favicons/[name].[ext]!./src/assets/favicons/mstile-144x144.png
// module id = lSMl
// module chunks = 1